<template>
  <header class="py-3 bg-secondary">
    <div class="container">
      <div class="tx-18 text-white">{{ comp.task }}</div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style></style>
